import { AuthGuard } from "@redotech/redo-customer-portal-app/contexts/auth";
import { Page } from "@redotech/redo-customer-portal-app/portal-four/shared-components/page";
import { t } from "@redotech/redo-i18n";
import { RouteObject } from "react-router-dom";

export const withdrawalRoutes: RouteObject[] = [
  {
    path: ":withdrawalId",
    lazy: async () => {
      const { WithdrawalConfirmation } =
        // redont-allow-dynamic-import: route-level code splitting
        await import("@redotech/redo-customer-portal-returns-app/returns/withdrawal-confirmation-page");
      return {
        element: (
          <AuthGuard
            unauthorizedMessage={t(
              "You need to login again to see this withdrawal.",
            )}
          >
            <Page>
              <WithdrawalConfirmation />
            </Page>
          </AuthGuard>
        ),
      };
    },
  },
];
